import { render, staticRenderFns } from "./AdminRegistrationsTable.vue?vue&type=template&id=4893b8bb"
import script from "./AdminRegistrationsTable.vue?vue&type=script&lang=js"
export * from "./AdminRegistrationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports